import { ValueProvider } from '@angular/core';
import { DYNAMIC_MATCHERS, DynamicFormControlMatcher, DynamicFormValueControlModel, REQUIRED_MATCHER } from '@ng-dynamic-forms/core';

// Custom required matcher that sets "required" property on model, as expected
export const CustomRequiredMatcher: DynamicFormControlMatcher = {
  ...REQUIRED_MATCHER,
  onChange(hasMatch, model, control, injector) {
    (model as DynamicFormValueControlModel<any>).required = hasMatch;
    REQUIRED_MATCHER.onChange(hasMatch, model, control, injector);
  }
};

export const CUSTOM_REQUIRED_MATCHER_PROVIDER: ValueProvider = {
  provide:  DYNAMIC_MATCHERS,
  useValue: CustomRequiredMatcher,
  multi:    true
};
